@if ((!id || dataObject) && clientLayout) {
  <div class="dashboard">
    <mrd-form
      #mrdFormEl
      [layout]="clientLayout"
      [values]="formValues"
      [locale]="locale"
      [me]="me"
      [referenceHref]="referenceHref"
      [referenceClass]="referenceClass"
      [showCancel]="true"
      [showDelete]="showDelete && !!id"
      (mrdSubmit)="onMrdSubmit($any($event))"
      (mrdCancel)="onCancel()"
      (mrdDelete)="onMrdDelete()"
      (mrdSearch)="onMrdSearch($any($event))"
      (mrdLoadObject)="onMrdLoadObject($any($event))"
      (mrdFetchAll)="onMrdFetchAll($any($event))"
      (mrdUpload)="onMrdUpload($any($event))">
    </mrd-form>
  </div>

  @if (deleteConfirmOpen) {
    <div class="overlay-backdrop" (click)="cancelDelete()">
      <div class="overlay-panel overlay-panel--confirm" (click)="$event.stopPropagation()">
        <h2 class="confirm-dialog__title">{{ 'confirm.delete_title' | translate }}</h2>
        <p class="confirm-dialog__body">
          <strong>{{ dataObject?.name }}</strong><br>
          {{ 'confirm.delete_body' | translate }}
        </p>
        <div class="confirm-dialog__actions">
          <a class="btn btn--basic" href="javascript:void(0)" (click)="cancelDelete()">
            {{ 'confirm.cancel' | translate }}
          </a>
          <a class="btn btn--danger" href="javascript:void(0)" (click)="confirmDelete()">
            {{ 'confirm.delete' | translate }}
          </a>
        </div>
      </div>
    </div>
  }
}
